import Vue from 'vue'
import Router from 'vue-router'
import ChatsView from '@/components/ChatsView'
import Login from '@/components/Login'
import Privacy from '@/components/Privacy'
import About from '@/components/About'
import TOS from '@/components/TOS'
import SmoothEdit from '@/components/SmoothEdit'
import SmoothPlayback from '@/components/Playback/SmoothPlayback'
Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'privacy',
      path: '/privacy',
      component: Privacy,
      props: false
    },
    {
      name: 'about',
      path: '/about',
      component: About,
      props: false
    },
    {
      name: 'playback',
      path: '/play/:id',
      component: SmoothPlayback,
      props: true
    },
    {
      path: '/content',
      name: 'content',
      component: ChatsView
    },
    {
      path: '/edit/:id',
      name: 'edit',
      component: SmoothEdit,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/tos',
      name: 'tos',
      component: TOS
    },
    {
      path: '/',
      name: 'root',
      component: ChatsView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js